<template>
  <b-modal id="createAgreementDeviceModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.excmagreementdevice.createAgreementDeviceHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <EXCMAgreementDeviceCreate :agreementIRI="agreementIRI"></EXCMAgreementDeviceCreate>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import EXCMAgreementDeviceCreate from '../Create.vue'
export default {
  name: 'CreateAgreementDeviceModal',
  components: {
    EXCMAgreementDeviceCreate
  },
  computed: {
    show () {
      return this.$store.state.modals.excmagreementdevice.create.show
    },
    computedAgreementIRI () {
      return this.$store.state.modals.excmagreementdevice.create.agreementIRI
    },
    close () {
      return this.$store.state.modals.excmagreementdevice.create.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      agreementIRI: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.computedAgreementIRI) {
        this.agreementIRI = this.$store.state.modals.excmagreementdevice.create.agreementIRI
        this.$store.state.modals.excmagreementdevice.create.show = 0
        this.$store.state.modals.excmagreementdevice.create.agreementIRI = null
        this.$bvModal.show('createAgreementDeviceModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.excmagreementdevice.create.close = 0
        this.$bvModal.hide('createAgreementDeviceModal')
      }
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
